module.exports = __webpack_public_path__ + "static/media/wpir.5c026eb0.png";